export const faqsReducer = (state = { content: [], loading: true, dataLoaded: false }, action) => {
    switch (action.type) {
      case 'FAQ_REQUEST':
        return { ...state, loading: true };
      case 'FAQ_SUCCESS':
        return { 
          ...state, 
          loading: false, 
          content: action.payload,
          dataLoaded: true
        };
      case 'FAQ_FAIL':
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  